import { createBehavior } from '@area17/a17-behaviors';
import * as FocusTrap from 'focus-trap';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import navStore from '../stores/nav';

const menu = createBehavior(
  'menu',
  {
    open() {
      this.isOpen = true;
      this.$node.dispatchEvent(new CustomEvent('menu:open', {}));
      this.$node.inert = false;
      setTimeout(() => {
        this.focusTrap.activate();
      }, 0);

      // this.$closeBtn.addEventListener('click', this.onCloseBtnClick);
      disableBodyScroll(this.$node, {
        reserveScrollBarGap: true,
      });
      // this.$node.addEventListener('keyup', this.onKeyUpWhenOpen);
      this.onOpenChange();
    },
    // onKeyUpWhenOpen(evt) {
    //   if (evt.key === 'Escape') {
    //     this.close();
    //   }
    // },
    onCloseBtnClick() {
      navStore.setState({ open: false });
    },
    close() {
      this.isOpen = false;
      this.$node.dispatchEvent(new CustomEvent('menu:close', {}));
      // this.$node.removeEventListener('keyup', this.onKeyUpWhenOpen);
      this.focusTrap.deactivate();
      this.$node.inert = true;
      enableBodyScroll(this.$node);
      this.$closeBtn.removeEventListener('click', this.onCloseBtnClick);
      this.onOpenChange();
    },
    onOpenChange() {
      // We can guarantee a boolean change at this point
      const isOpening = this.isOpen;
      const isClosing = !this.isOpen;

      if (this.frameTimeout) {
        clearTimeout(this.frameTimeout);
      }

      if (this.animationTimeout) {
        clearTimeout(this.animationTimeout);
      }

      if (this.disableTimeout) {
        clearTimeout(this.disableTimeout);
      }

      this.disableTimeout = setTimeout(() => {
        if (this.isOpen) {
          this.$closeBtn.addEventListener('click', this.onCloseBtnClick);
        }
      }, 900);

      // Cleanup
      this.$node.classList.remove('menu:is-closing');
      this.$node.classList.remove('menu:is-opening');
      this.$node.classList.toggle('menu:is-open', isOpening);
      this.$node.classList.toggle('menu:is-closing', isClosing);
      this.$node.classList.toggle('menu:is-opening', isOpening);
      this.$node.classList.add('menu:is-animating');

      this.$inner.addEventListener('transitionend', () => {
        this.$node.classList.remove('menu:is-animating');
        this.$node.classList.remove('menu:is-closing');
        this.$node.classList.remove('menu:is-opening');
      });
    },
    onPrimaryLinkMouseOver() {
      this.primaryLinkOverCount += 1;
      this.primaryLinkRender();
    },
    onPrimaryLinkMouseOut() {
      this.primaryLinkOverCount -= 1;
      this.primaryLinkRender();
    },
    primaryLinkRender() {
      this.$node.classList.toggle(
        'is-primary-over',
        this.primaryLinkOverCount > 0
      );
    },
  },
  {
    init() {
      this.disableTimeout = null;
      this.$inner = this.getChild('inner');
      this.$closeBtn = this.getChild('close-btn');
      this.$primaryLinks = this.getChildren('primary-link');
      this.frameTimeout = null;
      this.animationTimeout = null;
      this.$node.inert = true;
      this.unsubscribe = navStore.subscribe((state) => {
        if (state.open === this.isOpen) {
          return;
        }
        if (state.open) {
          this.open();
        } else {
          this.close();
        }
      });

      this.primaryLinkOverCount = 0;
      for (const $link of this.$primaryLinks) {
        $link.addEventListener('mouseover', this.onPrimaryLinkMouseOver);
        $link.addEventListener('mouseout', this.onPrimaryLinkMouseOut);
      }

      this.focusTrap = FocusTrap.createFocusTrap(this.$node, {
        preventScroll: true,
        escapeDeactivates: () => {
          navStore.setState({ open: false });
        },
        allowOutsideClick: true,
        onActivate: () => {},
        onDeactivate: () => {},
      });
    },
    destroy() {
      this.focusTrap.deactivate();
      this.$closeBtn.removeEventListener('click', this.onCloseBtnClick);
      this.unsubscribe();

      for (const $link of this.$primaryLinks) {
        $link.removeEventListener('mouseover', this.onPrimaryLinkMouseOver);
        $link.removeEventListener('mouseout', this.onPrimaryLinkMouseOut);
      }
    },
  }
);

export default menu;
